export * from "@vaadin/breadcrumbs/vaadin-breadcrumbs-item.js";
export * from './generated/BreadcrumbsItem.js';
